module.exports = __webpack_public_path__ + "static/media/2-option6-4row.d5e89af0.png";